<div class="modal-background"></div>
<div class="modal" trapFocus>
    <div class="modal-body">
        <div class="modal-container">
            <ng-content></ng-content>
        </div>
    </div>
</div>
